import { AbstractControl, FormControl, ValidationErrors, Validators } from '@angular/forms';

/**
 * `Validators.email` refuses a value with a leading or trailing space, and an address pasted out of
 * a mail client routinely arrives with one. Every form here trims the address before sending it, so
 * validating the untrimmed string would block a sign-up it would otherwise have accepted. The error
 * key stays `email`, which is what the templates' `hasError('email')` reads.
 *
 * **Copied, not imported.** The same validator exists in core's `invite-user.dialog.ts` and is not
 * exported from `@processpuzzle/org-admin` — reaching into that file directly would be a deep import
 * into another library's internals, and adding an export to the core submodule for four lines is a
 * change to a vendored dependency. The duplication is deliberate and is noted in both places; if it
 * is ever exported, this file should go.
 */
export function trimmedEmail(control: AbstractControl): ValidationErrors | null {
  return typeof control.value === 'string' ? Validators.email(new FormControl(control.value.trim())) : Validators.email(control);
}
